export const mobile = {
  'backoffice.mobile.tabs.home': 'Home',
  'backoffice.mobile.tabs.accounts': 'Conti',
  'backoffice.mobile.tabs.profits': 'Profitti',
  'backoffice.mobile.tabs.commissions': 'Commissioni',
  'backoffice.mobile.tabs.more': 'Altro',
  'backoffice.mobile.more.myProfitHistory': 'Storico Profitti',
};
